// src/pages/PDFViewerPage.js
import React, { useEffect } from 'react';
import { useLocation, useSearchParams, useNavigate } from 'react-router-dom';
import PDFViewer from '../components/players/PDFViewer';

const PDFViewerPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const stateData = location.state || {};
  const fileUrl = stateData.fileUrl || searchParams.get('url') || '';
  const mediaId = stateData.mediaId || searchParams.get('mediaId') || null;
  const title = stateData.title || searchParams.get('title') || '';
  const productTitle = stateData.productTitle || title || '';  // ✅ عنوان محصول

  useEffect(() => {
    if (!fileUrl && !mediaId) {
      navigate(-1);
    }
  }, [fileUrl, mediaId, navigate]);

  if (!fileUrl && !mediaId) {
    return null;
  }

  return (
    <div className="h-screen bg-gray-100 flex flex-col">
      <div className="flex-1">
        <PDFViewer
          mediaId={mediaId}
          fileUrl={fileUrl}
          title={title}
          productTitle={productTitle}  // ✅ عنوان محصول
        />
      </div>
    </div>
  );
};

export default PDFViewerPage;